<h2 mat-dialog-title>
  <span class="summary-board-tasks-header">{{ data?.title }}</span>
</h2>

<mat-dialog-content class="summary-board-tasks-content display-flex flex-column grid-gap-16">
  <div class="display-flex menu-content-search">
    <app-input
      class="w-100"
      [matFormCss]="'border-radius-partial-left'"
      [formControl]="searchControl"
      [attrPlaceholder]="'Search...'"
      [attrDisable]="false"
      [attrType]="'text'"
      [attrAutocomplete]="false"></app-input>

    <div class="search-icon display-flex align-items-center justify-content-center">
      <app-icon
        [svg]="EIcon.ICON_SEARCH"
        [iconColor]="EColorPalette.cGray7"
        [iconWidth]="18"
        [iconHeight]="18"></app-icon>
    </div>
  </div>

  <div class="summary-board-tasks-container">
    <ng-container *ngIf="filteredBoards?.length; else emptyState">
      <div class="summary-board-tasks-list">
        <a
          *ngFor="let board of filteredBoards; trackBy: trackById"
          class="summary-board-tasks-link"
          [href]="getBoardUrl(board.id)"
          target="_blank"
          rel="noopener">
          {{ board.name }}
        </a>
      </div>
    </ng-container>
    <ng-template #emptyState>
      <div class="summary-board-tasks-empty">No matching boards</div>
    </ng-template>
  </div>
</mat-dialog-content>

<mat-dialog-actions class="display-flex align-items-center justify-content-end grid-gap-16">
  <button class="summary-board-tasks-modal-button" mat-stroked-button color="primary" (click)="close()">Close</button>
</mat-dialog-actions>
